'use strict';

(function () {
	angular.module('loaderBlock', []);
})();